import { Injectable, signal, effect } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LocalStorageKeys } from '../../enums/local-storage-keys.enum';

@Injectable({
  providedIn: 'root',
})
export class LangService {
  language = signal<string>(localStorage.getItem(LocalStorageKeys.Lang) || 'en');

  constructor(private translate: TranslateService) {
    effect(() => {
      const currentLang = this.language();
      localStorage.setItem(LocalStorageKeys.Lang, currentLang);
      this.translate.use(currentLang);
      this.translate.setDefaultLang(currentLang);
    });
  }

  setLanguage(lang: string): void {
    this.language.set(lang);
  }

  getLanguage(): string {
    return this.language();
  }
}
